import React, { useState } from "react";
import lod_ from "lodash";
import { useSelector } from "react-redux";

import Fab from "@mui/material/Fab";
import Paper from "@mui/material/Paper";
import { Icon, Typography, CircularProgress } from "@mui/material";

import DashboardLayout from "components/Advanced/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Advanced/Navbars/DashboardNavbar";
import SourceManagment from "./components/SourceManagment";
import AssetFilters from "./AssetFilters";
import { selectKnowledgeBaseConfig } from "redux-react/reducers/knowledgeBaseReducer";
import MDBox from "components/Basics/MDBox";
import useChatbotScript from "hooks/useChatbotScript";
import { getKnowledgeBaseChatbotConfig } from "redux-react/reducers/applicationReducer";

const KnowledgeBase = () => {
	const knowledgeBaseConfig = useSelector(selectKnowledgeBaseConfig);
	const chatbotConfig = useSelector(getKnowledgeBaseChatbotConfig);

	useChatbotScript({
		apiKey: chatbotConfig?.apiKey,
		scriptUrl: chatbotConfig?.scriptUrl
	});

	const { profile } = useSelector(state => state);

	const [chatOpen, setChatOpen] = useState(false);

	const [filters, setFilters] = useState({
		status: [],
		access: [],
		type: [],
		dateStart: "",
		dateEnd: ""
	});

	const handleFilterChange = (filterType, value) => {
		setFilters(prev => ({
			...prev,
			[filterType]: value
		}));
	};

	return (
		<DashboardLayout
			style={{
				height: "100vh",
				display: "flex",
				flexDirection: "column"
			}}
		>
			<DashboardNavbar
				filters={[
					[
						<AssetFilters
							key="asset-filters"
							filters={filters}
							onFilterChange={handleFilterChange}
						/>
					]
				]}
			/>
			<br />
			{!lod_.isEmpty(knowledgeBaseConfig?.code) && (
				<SourceManagment
					key={knowledgeBaseConfig?.code} // Very important to reset the component state when knowledge base changes
					assistantID={profile?.assistantID}
					activeFilters={filters}
				/>
			)}
			{lod_.isEmpty(knowledgeBaseConfig?.code) && knowledgeBaseConfig?.empty !== true && (
				<MDBox display="flex" justifyContent="center" alignItems="center" height="50vh" flex="1">
					<CircularProgress color="info" size={50} />
				</MDBox>
			)}
			{knowledgeBaseConfig?.empty === true && (
				<MDBox
					display="flex"
					justifyContent="center"
					alignItems="center"
					height="50vh"
					flexDirection="column"
					gap={2}
				>
					<Typography variant="h6" color="text.secondary">
						Aucune base de connaissances disponible.
					</Typography>
				</MDBox>
			)}
			{lod_.isEmpty(knowledgeBaseConfig?.testRuntimeCode) && (
				<MDBox position="fixed" right={24} bottom={24} zIndex={1200}>
					<Paper
						elevation={6}
						sx={{
							mb: 1.5,
							p: 2,
							maxWidth: 260,
							borderRadius: 3,
							background: "#fff",
							transform: chatOpen ? "translateY(0) scale(1)" : "translateY(16px) scale(0.95)",
							opacity: chatOpen ? 1 : 0,
							pointerEvents: chatOpen ? "auto" : "none",
							transition: "transform 0.25s ease, opacity 0.25s ease"
						}}
					>
						<MDBox display="flex" alignItems="center" mb={1} gap={1}>
							<Icon color="warning" fontSize="small">
								chat_bubble_outline
							</Icon>
							<Typography variant="subtitle2" fontWeight="bold" color="text.secondary">
								Chat désactivé
							</Typography>
						</MDBox>
						<Typography variant="body2" color="text.secondary">
							Aucun scénario de test configuré. Veuillez en configurer un dans les paramètres de la
							base de connaissances.
						</Typography>
					</Paper>
					<MDBox display="flex" justifyContent="flex-end">
						<Fab
							color="warning"
							aria-label="chat-disabled"
							onClick={() => setChatOpen(prev => !prev)}
							sx={{ opacity: 0.6 }}
						>
							<Icon fontSize="medium">announcement</Icon>
						</Fab>
					</MDBox>
				</MDBox>
			)}
		</DashboardLayout>
	);
};

export default KnowledgeBase;
